$(document).on('show.bs.modal','.sign-modal', function (e) {
  let docId = e.relatedTarget.getAttribute('data-doc');

  $('#sign_document_select-' + docId).select2({
    dropdownParent: $('#signDocumentModal-' + docId)
  });
})
